<template>
  <section class="section pt-1 bg-white">
    <div class="container">
      <h1 class="mb-4">{{ $t("help.platform.legal-document.text") }}</h1>

      <div role="tablist">
        <b-card no-body class=" shadow-none mb-3">
          <b-card-body>
            <p class="mb-3">
              {{ $t("help.platform.legal-document.line-1") }}
            </p>

            <p>{{ $t("help.platform.legal-document.line-2") }}</p>
          </b-card-body>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1' ? 'founded' : ''" v-b-toggle.col1>
              <div>{{ $t("help.platform.legal-document.template.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col1" :visible="col == 'col1'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-0">
                {{ $t("help.platform.legal-document.template.line-1") }}
              </p>
              <img src="@/assets/images/help/legal-document.png" class="image" />

              <p class="mt-3 mb-3">
                {{ $t("help.platform.legal-document.template.line-2") }}
              </p>

              <img src="@/assets/images/help/legal-document-edit.png" class="image" />

              <p class="mt-3 mb-3">
                {{ $t("help.platform.legal-document.template.line-3") }}
              </p>

              <p class="mt-3 mb-3">
                {{ $t("help.platform.legal-document.template.line-4") }}
              </p>
              <p class="mt-3 mb-3">
                {{ $t("help.platform.legal-document.template.line-5") }}
              </p>
              <p class="mt-3 mb-3">
                {{ $t("help.platform.legal-document.template.line-6") }}
              </p>
              <p class="mt-3 mb-3">
                {{ $t("help.platform.legal-document.template.line-7") }}
              </p>
              <p class="mt-3 mb-3">
                {{ $t("help.platform.legal-document.template.line-8") }}
              </p>
              <img src="@/assets/images/help/legal-document-templates.png" class="image" />
              <p class="mt-3 mb-3">
                {{ $t("help.platform.legal-document.template.line-9") }}
              </p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1' ? 'founded' : ''" v-b-toggle.col1>
              <div>{{ $t("help.platform.legal-document.control.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col1" :visible="col == 'col1'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-0">
                {{ $t("help.platform.legal-document.control.line-1") }}
              </p>
              <img src="@/assets/images/help/legal-document-control.png" class="image" />

              <p class="mt-3 mb-3">
                {{ $t("help.platform.legal-document.control.line-2") }}
              </p>

              <p class="mt-3 mb-3">
                {{ $t("help.platform.legal-document.control.line-3") }}
              </p>
              <img src="@/assets/images/help/file-upload-modal.png" class="image" />

              <p class="mt-3 mb-3">
                {{ $t("help.platform.legal-document.control.line-4") }}
              </p>

              <a class="mt-3" href="/kvkk/legal-document-template">
                <p><i class="bx bx-support"></i> {{ $t("help.platform.legal-document.control.line-5") }}</p>
              </a>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col2' ? 'founded' : ''" v-b-toggle.col2>
              <div>{{ $t("help.platform.legal-document.legal-document.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col2" :visible="col == 'col2'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-0">
                {{ $t("help.platform.legal-document.legal-document.line-1") }}
              </p>
              <img src="@/assets/images/help/legal-documents.png" class="image" />

              <p class="mt-3 mb-3">
                {{ $t("help.platform.legal-document.legal-document.line-2") }}
              </p>

              <a class="mt-3" href="/organization/file-manager">
                <p><i class="bx bx-support"></i> {{ $t("help.platform.legal-document.legal-document.line-3") }}</p>
              </a>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      col: "col1",
    };
  },
  mounted() {
    setTimeout(() => {
      const { col } = this.$route.query;
      this.col = col;
      window.scrollTo({ top: 700, behavior: "smooth" });
    }, 500);
  },
};
</script>

<style scoped>
.founded {
  background: yellow !important;
}
.image {
  display: block;
  max-width: 100%;
}
</style>
